module.exports = __webpack_public_path__ + "510dd67ef23fc5557a7d1f6d43d36dbc.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-grady.png
// module id = 656
// module chunks = 0